/* eslint-disable max-len */
import logo from "assets/Logo.svg";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <div className="w-full sticky top-0 left-0 z-10 bg-mono-tertiary h-[72px] flex justify-center items-center border-b border-mono-75">
      <Link to="/login">
        <img src={logo} alt="logo" />
      </Link>
    </div>
  );
}
